/**
 * Assets de marque — rollback logo : remplacer logo.png par logo.placeholder.svg
 */
import logoPng from '../assets/images/logo.png';
import logoPlaceholder from '../assets/images/logo.placeholder.svg';

/** true = logo association coloré | false = ancien placeholder SVG */
export const USE_KHAYR_LOGO = true;

export const brandLogo = USE_KHAYR_LOGO ? logoPng : logoPlaceholder;

/** Couleurs programmes alignées sur le logo */
export const PROGRAM_BRAND_COLORS = {
  adahi: 'text-brand-red',
  ihyaa: 'text-brand-red',
  namaa: 'text-brand-green',
  kafala: 'text-brand-primary',
  saqya: 'text-brand-primary-light',
  ighatha: 'text-brand-orange',
  imaar: 'text-brand-yellow',
  ramadan: 'text-brand-orange',
};

export const PROGRAM_ICON_CLASSES = [
  'text-brand-red',
  'text-brand-orange',
  'text-brand-primary',
  'text-brand-yellow',
];
